import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  Directions,
  systemConstants,
  translationConstants,
} from "../../../../../../../constants";
import DummyImage from "../../../../../../../assets/images/icon/dummyCenterLogo.png";
import CenterInfoCard from "../../../../../../../shared/components/ViewCenterCard/CenterInfoCard";
import {
  BoatIcon,
  PhoneIcon,
  HoursIcon,
  TiktokIcon,
  WebsiteIcon,
  TwitterIcon,
  StudentIcon,
  MessageIcon,
  FacebookIcon,
  LinkedInIcon,
  LocationsIcon,
  InstagramIcon,
  InstructorIcon,
  SecondBoatIcon,
  LocationPinIcon,
} from "../../../../../../../assets/images/icon/iconsProvider";
import { getSportNames } from "../../../../../../AdminPortal/Views/Spots/utilities";

const General = (props) => {
  const { t, i18n } = useTranslation();

  //-------reducers
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const cities = useSelector((state) => state.LoginReducer.cities);
  let centerLogo = useSelector((state) => state.centersReducer.centerLogo);

  //-------Destructure Props
  const { centerProfileData } = props;

  const getCityName = (cityId) => {
    //Find the city object with the matching ID from the array of cities
    const city = cities.find((city) => city.id === cityId);

    //Return the appropriate name based on the direction
    return direction === systemConstants.DIRECTION_RIGHT_TO_LEFT
      ? city?.arabicName
      : city?.name;
  };

  return (
    <>
      <div className="row m-0 px-2">
        <div className="col-md-6 d-flex align-items-end gap-3 p-0">
          <div className="center-logo-image-wrapper">
            <img
              src={centerLogo !== null ? centerLogo : DummyImage}
              alt="center-logo"
            />
          </div>
          <div className="d-flex flex-column justify-content-between h-100 align-items-start">
           {props.isShowCenter &&  <h3 className="h-100 center-name-heading">
              {direction == Directions.rtl &&
              centerProfileData?.centerInfo?.arabicName
                ? centerProfileData?.centerInfo?.arabicName
                : centerProfileData?.centerInfo?.name}
            </h3>}
            <div className="center-social-media-links d-flex justify-content-md-end align-items-md-end py-3 py-md-0">
              {centerProfileData?.centerInfo?.twitterURL && (
                <a
                  href={centerProfileData?.centerInfo?.twitterURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`bg-none`}
                >
                  <TwitterIcon className={`social-media-icon-twitter`} />
                </a>
              )}
              {centerProfileData?.centerInfo?.linkedinUrl && (
                <a
                  href={centerProfileData?.centerInfo?.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`bg-none`}
                >
                  <LinkedInIcon className={`social-media-icon`} />
                </a>
              )}
              {centerProfileData?.centerInfo?.facebookURL && (
                <a
                  href={centerProfileData?.centerInfo?.facebookURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`bg-none`}
                >
                  <FacebookIcon className={`social-media-icon`} />
                </a>
              )}
              {centerProfileData?.centerInfo?.instagramURL && (
                <a
                  href={centerProfileData?.centerInfo?.instagramURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`bg-none`}
                >
                  <InstagramIcon className={`social-media-icon`} />
                </a>
              )}
              {centerProfileData?.centerInfo?.tikTokURL && (
                <a
                  href={centerProfileData?.centerInfo?.tikTokURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`bg-none`}
                >
                  <TiktokIcon className={`social-media-icon`} />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="row m-0 mt-3 px-1 justify-content-center justify-content-md-start">
          <div className="col-5 col-md-2 my-2 mx-1 p-0">
            <CenterInfoCard
              IconImage={BoatIcon}
              label={translationConstants.SPORTS}
              value={centerProfileData?.noOfSports}
            />
          </div>
          <div className="col-5 col-md-2 my-2 mx-1 p-0">
            <CenterInfoCard
              IconImage={StudentIcon}
              label={translationConstants.STUDENTS}
              value={centerProfileData?.noOfStudents}
            />
          </div>
          <div className="col-5 col-md-2 my-2 mx-1 p-0">
            <CenterInfoCard
              IconImage={InstructorIcon}
              label={translationConstants.INSTRUCTORS}
              value={centerProfileData?.noOfInstructors}
            />
          </div>
          <div className="col-5 col-md-2 my-2 mx-1 p-0">
            <CenterInfoCard
              IconImage={LocationsIcon}
              label={translationConstants.LOCATIONS}
              value={centerProfileData?.noOfSpots}
            />
          </div>
          <div className="col-5 col-md-2 my-2 mx-1 p-0">
            <CenterInfoCard
              IconImage={HoursIcon}
              label={translationConstants.HOURS}
              value={centerProfileData?.noOfHours}
            />
          </div>
        </div>
      </div>
      <div className="row m-0 px-1">
        <div className="col-12 col-md-6 my-3 p-0">
          <div className="information-card-2nd">
            <LocationPinIcon className="information-2nd-card-icon" />
            <div className="d-flex flex-column">
              <span className="second-card-heading-text">
                {t(translationConstants.LOCATION)}
              </span>
              <span className="second-card-description-text">
                {getCityName(centerProfileData?.centerInfo?.cityId)}
              </span>{" "}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 my-3 p-0">
          <div className="information-card-2nd">
            <BoatIcon className="information-2nd-card-icon h-35" />
            <div className="d-flex flex-column">
              <span className="second-card-heading-text">
                {t(translationConstants.SPORTS_OFFERED)}
              </span>
              <span className="second-card-description-text">
                {getSportNames(centerProfileData?.sportIds)}
              </span>{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0 px-1">
        <div className="col-md-10 pt-2 ">
          <div className="contact-information-card-wrapper ">
            <span className="second-card-heading-text">
              {t(translationConstants.CONTACT_INFORMATION)}
            </span>
            <div className="d-flex align-items-center flex-wrap gap-x-5">
              <div className={`contact-information-card pt-2`}>
                <PhoneIcon />
                <span dir={Directions.ltr}>
                  {centerProfileData?.centerInfo?.phoneNumber}
                </span>
              </div>
              <div className="contact-information-card pt-2">
                <MessageIcon />
                <span>{centerProfileData?.centerInfo?.email}</span>
              </div>
              <div className="contact-information-card pt-2">
                {centerProfileData?.centerInfo?.websiteURL && (
                  <>
                    <WebsiteIcon />
                    <span>{centerProfileData?.centerInfo?.websiteURL}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {(direction === Directions.rtl &&
        centerProfileData?.centerInfo?.arabicDescription
          ? true
          : centerProfileData?.centerInfo?.description) && (
          <div className="col-md-10 pt-4 d-flex flex-column gap-2">
            <span className="second-card-heading-text">
              {t(translationConstants.DESCRIPTION)}
            </span>{" "}
            <span className="second-card-description-text">
              {direction === systemConstants.DIRECTION_RIGHT_TO_LEFT &&
              centerProfileData?.centerInfo?.arabicDescription
                ? centerProfileData?.centerInfo?.arabicDescription
                : centerProfileData?.centerInfo?.description}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default General;
